import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useClient } from "../../context/client-context";

const FooterOneMain = () => {
  const client = useClient();
  const { companyProfile } = useSelector((state) => state.system);

  const message =
    "Hello! I'm interested in your products and would like to know more.";

  return (
    <footer className="footer py-120">
      <a
        href={`https://wa.me/${client.contact}?text=${encodeURIComponent(message)}.`}
        className="whatsapp-float"
        target="_blank"
        rel="noreferrer"
      >
        <img
          src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
          className="img-fluid"
          alt="whatsapp"
          width="30"
        />
      </a>
      {/* <img
        src="/assets/images/bg/body-bottom-bg.png"
        alt="BG"
        className="body-bottom-bg"
      /> */}
      <div className="container container-lg">
        <div className="footer-item-wrapper d-flex align-items-start flex-wrap justify-content-between">
          <div className="footer-item">
            <div className="footer-item__logo">
              <Link to="/">
                <img
                  // src="/assets/images/logo/phamacart.png"
                  // src="/assets/images/logo/averon.jpeg"
                  src={client.logo}
                  alt={client.name}
                  className="company_logo"
                />
              </Link>
            </div>
            <p className="mb-24">
              Your trusted online pharmaceutical partner,
              <br /> providing quality medicines, wellness, beauty,
              <br /> healthcare products, medical supplies,
              <br /> and pet care solutions for everyone.
            </p>
            <ul className="flex-align gap-16">
              <li>
                <Link
                  to="/https://www.facebook.com"
                  className="w-44 h-44 flex-center bg-main-100 text-main-600 text-xl rounded-circle hover-bg-main-600 hover-text-white"
                >
                  <i className="ph-fill ph-facebook-logo" />
                </Link>
              </li>
              <li>
                <Link
                  to="/https://www.twitter.com"
                  className="w-44 h-44 flex-center bg-main-100 text-main-600 text-xl rounded-circle hover-bg-main-600 hover-text-white"
                >
                  <i className="ph-fill ph-twitter-logo" />
                </Link>
              </li>
              <li>
                <Link
                  to="/https://www.linkedin.com"
                  className="w-44 h-44 flex-center bg-main-100 text-main-600 text-xl rounded-circle hover-bg-main-600 hover-text-white"
                >
                  <i className="ph-fill ph-instagram-logo" />
                </Link>
              </li>
              <li>
                <Link
                  to="/https://www.pinterest.com"
                  className="w-44 h-44 flex-center bg-main-100 text-main-600 text-xl rounded-circle hover-bg-main-600 hover-text-white"
                >
                  <i className="ph-fill ph-linkedin-logo" />
                </Link>
              </li>
            </ul>
          </div>
          <div className="footer-item">
            <h6 className="footer-item__title">Information</h6>
            <ul className="footer-menu">
              <li className="mb-16">
                <Link to="#" className="text-gray-600 hover-text-main-600">
                  Privacy Policy
                </Link>
              </li>
              <li className="mb-16">
                <Link to="#" className="text-gray-600 hover-text-main-600">
                  Return Policy
                </Link>
              </li>
              <li className="mb-16">
                <Link to="#" className="text-gray-600 hover-text-main-600">
                  Terms & Conditions
                </Link>
              </li>
              <li className="mb-16">
                <Link to="#" className="text-gray-600 hover-text-main-600">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
          <div className="footer-item">
            <h6 className="footer-item__title">My Offers</h6>
            <ul className="footer-menu">
              <li className="mb-16">
                <Link
                  to="/products/category?sortBy=bestsellers&onlyBestSeller=true"
                  className="text-gray-600 hover-text-main-600"
                >
                  Best Sellers
                </Link>
              </li>
              <li className="mb-16">
                <Link
                  to="/products/category?sortBy=newest&OnlyNewestArrival=true"
                  className="text-gray-600 hover-text-main-600"
                >
                  New Arrivals
                </Link>
              </li>
              <li className="mb-16">
                <Link
                  to="/products/category?sortBy=dealoftheday&onlyDealOfTheDay=true"
                  className="text-gray-600 hover-text-main-600"
                >
                  Deal of Day
                </Link>
              </li>
            </ul>
          </div>
          <div className="footer-item">
            <h6 className="footer-item__title">My Account</h6>
            <ul className="footer-menu">
              <li className="mb-16">
                <Link
                  to="/customer/account"
                  className="text-gray-600 hover-text-main-600"
                >
                  My Account
                </Link>
              </li>
              <li className="mb-16">
                <Link to="#" className="text-gray-600 hover-text-main-600">
                  Order History
                </Link>
              </li>
              <li className="mb-16">
                <Link to="/cart" className="text-gray-600 hover-text-main-600">
                  Shopping Cart
                </Link>
              </li>
              {/* <li className="mb-16">
                  <Link to="#" className="text-gray-600 hover-text-main-600">
                    Compare
                  </Link>
                </li> */}
              {/* <li className="mb-16">
                <Link to="#" className="text-gray-600 hover-text-main-600">
                  Help Ticket
                </Link>
              </li> */}
              {/* <li className="">
                  <Link to="#" className="text-gray-600 hover-text-main-600">
                    Wishlist
                  </Link>
                </li> */}
            </ul>
          </div>
          <div className="footer-item">
            <h6 className="footer-item__title">Licensed Pharmacy</h6>
            <div className="img-card">
              <img
                src={companyProfile?.pharmacyLicenseUrl}
                className="img-fluid"
                width="100"
                alt="Pharmacy and Poisons Board"
              />
            </div>
            {/* <ul className="footer-menu">
              <li className="mb-16">
                <Link to="/shop" className="text-gray-600 hover-text-main-600">
                  Become a Vendor
                </Link>
              </li>
            </ul> */}
          </div>
          {/* <div className="footer-item">
            <h6 className="footer-item__title">Information</h6>
            <ul className="footer-menu">
              <li className="mb-16">
                <Link to="/shop" className="text-gray-600 hover-text-main-600">
                  Become a Vendor
                </Link>
              </li>
              <li className="mb-16">
                <Link to="/shop" className="text-gray-600 hover-text-main-600">
                  Affiliate Program
                </Link>
              </li>
              <li className="mb-16">
                <Link to="/shop" className="text-gray-600 hover-text-main-600">
                  Privacy Policy
                </Link>
              </li>
              <li className="mb-16">
                <Link to="/shop" className="text-gray-600 hover-text-main-600">
                  Our Suppliers
                </Link>
              </li>
              <li className="mb-16">
                <Link to="/shop" className="text-gray-600 hover-text-main-600">
                  Extended Plan
                </Link>
              </li>
              <li className="">
                <Link to="/shop" className="text-gray-600 hover-text-main-600">
                  Community
                </Link>
              </li>
            </ul>
          </div>
          <div className="footer-item">
            <h6 className="footer-item__title">Customer Support</h6>
            <ul className="footer-menu">
              <li className="mb-16">
                <Link to="/shop" className="text-gray-600 hover-text-main-600">
                  Help Center
                </Link>
              </li>
              <li className="mb-16">
                <Link
                  to="/contact"
                  className="text-gray-600 hover-text-main-600"
                >
                  Contact Us
                </Link>
              </li>
              <li className="mb-16">
                <Link to="/shop" className="text-gray-600 hover-text-main-600">
                  Report Abuse
                </Link>
              </li>
              <li className="mb-16">
                <Link to="/shop" className="text-gray-600 hover-text-main-600">
                  Submit and Dispute
                </Link>
              </li>
              <li className="mb-16">
                <Link to="/shop" className="text-gray-600 hover-text-main-600">
                  Policies &amp; Rules
                </Link>
              </li>
              <li className="">
                <Link to="/shop" className="text-gray-600 hover-text-main-600">
                  Online Shopping
                </Link>
              </li>
            </ul>
          </div>
          <div className="footer-item">
            <h6 className="footer-item__title">My Account</h6>
            <ul className="footer-menu">
              <li className="mb-16">
                <Link to="/shop" className="text-gray-600 hover-text-main-600">
                  My Account
                </Link>
              </li>
              <li className="mb-16">
                <Link to="/shop" className="text-gray-600 hover-text-main-600">
                  Order History
                </Link>
              </li>
              <li className="mb-16">
                <Link to="/shop" className="text-gray-600 hover-text-main-600">
                  Shoping Cart
                </Link>
              </li>
              <li className="mb-16">
                <Link to="/shop" className="text-gray-600 hover-text-main-600">
                  Compare
                </Link>
              </li>
              <li className="mb-16">
                <Link to="/shop" className="text-gray-600 hover-text-main-600">
                  Help Ticket
                </Link>
              </li>
              <li className="">
                <Link
                  to="/wishlist"
                  className="text-gray-600 hover-text-main-600"
                >
                  Wishlist
                </Link>
              </li>
            </ul>
          </div>
          <div className="footer-item">
            <h6 className="footer-item__title">Daily Groceries</h6>
            <ul className="footer-menu">
              <li className="mb-16">
                <Link to="/shop" className="text-gray-600 hover-text-main-600">
                  Dairy &amp; Eggs
                </Link>
              </li>
              <li className="mb-16">
                <Link to="/shop" className="text-gray-600 hover-text-main-600">
                  Meat &amp; Seafood
                </Link>
              </li>
              <li className="mb-16">
                <Link to="/shop" className="text-gray-600 hover-text-main-600">
                  Breakfast Food
                </Link>
              </li>
              <li className="mb-16">
                <Link to="/shop" className="text-gray-600 hover-text-main-600">
                  Household Supplies
                </Link>
              </li>
              <li className="mb-16">
                <Link to="/shop" className="text-gray-600 hover-text-main-600">
                  Bread &amp; Bakery
                </Link>
              </li>
              <li className="">
                <Link to="/shop" className="text-gray-600 hover-text-main-600">
                  Pantry Staples
                </Link>
              </li>
            </ul>
          </div>
          <div className="footer-item">
            <h6 className="">Shop on The Go</h6>
            <p className="mb-16">Marketpro App is available. Get it now</p>
            <div className="flex-align gap-8 my-32">
              <Link to="/https://www.apple.com/store" className="">
                <img src="/assets/images/thumbs/store-img1.png" alt="" />
              </Link>
              <Link to="/https://play.google.com/store/apps?hl=en" className="">
                <img src="/assets/images/thumbs/store-img2.png" alt="" />
              </Link>
            </div>
            <ul className="flex-align gap-16">
              <li>
                <Link
                  to="/https://www.facebook.com"
                  className="w-44 h-44 flex-center bg-main-100 text-main-600 text-xl rounded-circle hover-bg-main-600 hover-text-white"
                >
                  <i className="ph-fill ph-facebook-logo" />
                </Link>
              </li>
              <li>
                <Link
                  to="/https://www.twitter.com"
                  className="w-44 h-44 flex-center bg-main-100 text-main-600 text-xl rounded-circle hover-bg-main-600 hover-text-white"
                >
                  <i className="ph-fill ph-twitter-logo" />
                </Link>
              </li>
              <li>
                <Link
                  to="/https://www.linkedin.com"
                  className="w-44 h-44 flex-center bg-main-100 text-main-600 text-xl rounded-circle hover-bg-main-600 hover-text-white"
                >
                  <i className="ph-fill ph-instagram-logo" />
                </Link>
              </li>
              <li>
                <Link
                  to="/https://www.pinterest.com"
                  className="w-44 h-44 flex-center bg-main-100 text-main-600 text-xl rounded-circle hover-bg-main-600 hover-text-white"
                >
                  <i className="ph-fill ph-linkedin-logo" />
                </Link>
              </li>
            </ul>
          </div> */}
        </div>
      </div>
    </footer>
  );
};

export default FooterOneMain;
